import React, { useContext } from "react";
import { default as RBS_Modal, ModalProps } from "reactstrap/lib/Modal";
import { DesignContext } from "Components/DesignContext";

const Modal: React.FC<ModalProps> = (props) => {
   const designContext = useContext(DesignContext);
   return <RBS_Modal {...props} data-design={designContext.name} />
}

export default Modal;